// This file is auto-generated by the "tsproxygen.exe" tool. Manual modification is not recommended.
import type SearchFolderScopeType from '../contract/SearchFolderScopeType';

export default function searchFolderScopeType(data: SearchFolderScopeType): SearchFolderScopeType {
    const result: SearchFolderScopeType = {
        __type: 'SearchFolderScopeType:#Exchange',
        ...data,
    };

    return result;
}
